import { useMemo } from "react";

export const handleTypeHeaderIcon = (type) => {
  if (type === 'liquid_link') {
    return {
      header: "Liquid Link",
      label: "Liquid Link",
      icon: "fa-regular fa-object-exclude",
    };
  }

  const foundType = allQrTypes.find(t => t.type === type);
  const data = {
    header: foundType?.header || '',
    label: foundType?.header || '',
    icon: foundType?.icon || '',
  };
  return data;
};

export const useTypeHeaderIcon = (type) => useMemo(() => handleTypeHeaderIcon(type), [type]);

export const allQrTypes = [
  {
    type: 'pdf',
    header: 'PDF',
    icon: 'fa-solid fa-file-pdf'
  },
  {
    type: 'brochure',
    header: 'Brochure',
    icon: 'fa-solid fa-file'
  },
  {
    type: 'menu',
    header: 'Menu',
    icon: 'fa-solid fa-fork-knife'
  },
  {
    type: 'menu-pdf',
    header: 'Menu PDF',
    icon: 'fa-solid fa-fork-knife'
  },
  {
    type: 'menu-link',
    header: 'Menu Link',
    icon: 'fa-solid fa-utensils'
  },
  {
    type: 'location',
    header: 'Location',
    icon: 'fa-solid fa-map-location'
  },
  {
    type: 'bitsignal',
    header: 'BitSignal',
    icon: 'fak fa-bitsignal'
  },
  {
    type: 'liquid-label',
    header: 'Liquid Label',
    icon: 'fa-solid fa-tag'
  },
  {
    type: 'liquid-poster',
    header: 'Liquid Poster',
    icon: 'fa-regular fa-sheet-plastic'
  },
  {
    type: 'for-sale',
    header: 'For Sale',
    icon: 'fa-solid fa-barcode-read'
  },
  {
    type: 'garden-label',
    header: 'Garden Label',
    icon: 'fas fa-leaf',
  },
  {
    type: 'assets',
    header: 'Assets',
    icon: 'fa-solid fa-shelves'
  },
  {
    type: 'inventory',
    header: 'Inventory',
    icon: 'fa-solid fa-warehouse-full'
  },
  {
    type: 'tracker',
    header: 'Tracker',
    icon: 'fa-solid fa-clipboard-list-check'
  },
  {
    type: 'workout-log',
    header: 'Workout Log',
    icon: 'fa-solid fa-person-walking'
  },
  {
    type: 'service-log',
    header: 'Service Log',
    icon: 'fa-regular fa-table-list'
  },
  {
    type: 'survey',
    header: 'Liquid Feedback',
    icon: 'fa-regular fa-square-poll-vertical'
  },
  {
    type: 'review',
    header: 'Review Survey',
    icon: 'fa-solid fa-star-sharp-half-stroke'
  },
  {
    type: 'review-link',
    header: 'Review Link',
    icon: 'fa-regular fa-list-ul'
  },
  {
    type: 'quiz',
    header: 'Quiz',
    icon: 'fa-regular fa-school'
  },
  {
    type: 'appointment',
    header: 'Appointment',
    icon: 'fa-solid fa-calendar-days'
  },
  {
    type: 'calendly',
    header: 'Calendly',
    icon: 'fa-solid fa-calendar-days'
  },
  {
    type: 'google-calendar',
    header: 'Google Calendar',
    icon: 'fa-brands fa-google'
  },
  {
    type: 'google-review',
    header: 'Google Review',
    icon: 'fa-brands fa-google'
  },
  {
    type: 'contact-form',
    header: 'Contact Form',
    icon: 'fas fa-address-book'
  },
  {
    type: 'apple-music',
    header: 'Apple Music',
    icon: 'fa-brands fa-apple'
  },
  {
    type: 'spotify',
    header: 'Spotify',
    icon: 'fa-solid fa-music'
  },
  {
    type: 'youtube',
    header: 'YouTube',
    icon: 'fa-brands fa-youtube'
  },
  {
    type: 'tiktok',
    header: 'TikTok',
    icon: 'fa-brands fa-tiktok'
  },
  {
    type: 'twitch',
    header: 'Twitch',
    icon: 'fa-brands fa-twitch'
  },
  {
    type: 'facebook',
    header: 'Facebook',
    icon: 'fa-brands fa-facebook'
  },
  {
    type: 'instagram',
    header: 'Instagram',
    icon: 'fa-brands fa-instagram'
  },
  {
    type: 'linkedin',
    header: 'LinkedIn',
    icon: 'fa-brands fa-linkedin'
  },
  {
    type: 'microsite',
    header: 'Microsite',
    icon: 'fa-solid fa-square-list'
  },
  {
    type: 'landing-page',
    header: 'Landing Page',
    icon: 'fa-solid fa-browser'
  },
  {
    type: 'link',
    header: 'Link',
    icon: 'fa-solid fa-link-simple'
  },
  {
    type: 'vehicle-log',
    header: 'Vehicle Log',
    icon: 'fa-regular fa-car-side'
  },
  {
    type: 'container-label',
    header: 'Container Label',
    icon: 'fa-regular fa-tag'
  },
  {
    type: 'dbc',
    header: 'Digital Business Card',
    icon: 'fak fa-bitsignal'
  },
  {
    type: 'maintenance-tracker',
    header: 'Maintenance Tracker',
    icon: 'fa-regular fa-screwdriver-wrench'
  },
  {
    type: 'user-manual',
    header: 'User Manual',
    icon: 'fa-regular fa-book'
  },
  {
    type: 'connect',
    icon: 'fa-solid fa-airplay',
    label: 'QR Connect',
  },
];
